<template>
  <div style="width: 100%">
    <div style="height: 44px; background: #f0f0f0; position: relative">
      <span style="line-height: 44px; font-weight: 800; font-size: 18px; float: left">
        {{ title | LongtitleFilter }}
      </span>
      <div class="t-bar" style="position: absolute; right: 0; bottom: 0">
        <div class="b-right">
          <div class="b-search" @mouseenter="drawer(true)" @mouseleave="drawer(false)">
            <div class="s-input" v-show="sopen">
              <a-input placeholder="请输入查询内容" v-model="searchInput" />
            </div>
            <div class="s-btn" @click="searche"></div>
          </div>
          <div class="b-more" @click="detailsClick">更多></div>
        </div>
      </div>
    </div>
    <div>
      {{ list }}
    </div>
    <div v-show="(title === '土地半托') | (title === '土地全托')">
      <a-list bordered :data-source="listData">
        <a-list-item v-for="(item, index) of listData.slice(0, 5)" :key="index" :value="item.title">
          <a @click="TextcontentClick(item.id)" style="color: #000">
            <span style="float: left">{{ item.publishTitle | LongtitleFilter }}</span>
          </a>
          <a @click="TextcontentClick(item.id)" style="color: #000">
            <span style="float: right">{{ item.publishDate | moment('MM-DD') }} </span>
          </a>
        </a-list-item>
      </a-list>
    </div>
    <div v-show="(title === '供应信息') | (title === '求购信息')">
      <a-list bordered :data-source="SupplyAndDemandData">
        <a-list-item v-for="(item, index) of SupplyAndDemandData.slice(0, 5)" :key="index" :value="item.title">
          <a @click="SupplyAndDemandClick(item.id)" style="color: #000">
            <span style="float: left">{{ item.sdTitle | titleFilter }}</span>
          </a>
          <a @click="SupplyAndDemandClick(item.id)" style="color: #000">
            <span style="float: right">{{ item.publishDate | moment('MM-DD') }} </span>
          </a>
        </a-list-item>
      </a-list>
    </div>
    <!-- -->
    <div v-show="(title === '农技课堂') | (title === '庄稼医生')">
      <a-list bordered :data-source="InfoMainData">
        <a-list-item v-for="(item, index) of InfoMainData.slice(0, 5)" :key="index" :value="item.title">
          <a @click="InfoMainClick(item.id)" style="color: #000">
            <span style="float: left">{{ item.title | LongtitleFilter }}</span>
          </a>
          <a @click="InfoMainClick(item.id)" style="color: #000">
            <span style="float: right">{{ item.publishTime | moment('MM-DD') }} </span>
          </a>
        </a-list-item>
      </a-list>
    </div>
    <div v-show="(title === '农业贷款') | (title === '农业保险')">
      <a-list bordered :data-source="InfoMainData">
        <a-list-item v-for="(item, index) of InfoMainData.slice(0, 5)" :key="index" :value="item.title">
          <a @click="InfoMainClick(item.id)" style="color: #000">
            <span style="float: left">{{ item.title | LongtitleFilter }}</span>
          </a>
          <a @click="InfoMainClick(item.id)" style="color: #000">
            <span style="float: right">{{ item.publishTime | moment('MM-DD') }} </span>
          </a>
        </a-list-item>
      </a-list>
    </div>
    <div v-show="(title === '工作动态') | (title === '镇域介绍') | (title === '通知公告')">
      <a-list bordered :data-source="InfoMainData">
        <a-list-item v-for="(item, index) of InfoMainData.slice(0, 5)" :key="index" :value="item.title">
          <a @click="InfoMainClick(item.id)" style="color: #000">
            <span style="float: left">{{ item.title | LongtitleFilter }}</span>
          </a>
          <a @click="InfoMainClick(item.id)" style="color: #000">
            <span style="float: right">{{ item.publishTime | moment('MM-DD') }} </span>
          </a>
        </a-list-item>
      </a-list>
    </div>
  </div>
</template>
<script>
import { InfoMainWebPage } from '@/api/main/InfoMainManage'
import { LandTrustWebPage } from '@/api/main/LandTrustManager'
import { SupplyAndDemandInfoWebPage } from '@/api/main/SupplyAndDemandManager'
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    tType: {
      type: String,
      default: ''
    },
    // eslint-disable-next-line vue/prop-name-casing
    SdType: {
      type: String,
      default: ''
    },
    cType: {
      type: String,
      default: ''
    },
    infoType: {
      type: String,
      default: ''
    },
    list: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      orgId: '',
      listData: [],
      SupplyAndDemandData: [],
      InfoMainData: [],
      sopen: false,
      searchInput: ''
    }
  },
    filters: {
    titleFilter: (val) => {
      if (val.length > 16) {
      return val.slice(0, 16) + '...'
      } else {
      return val
      }
    },
    LongtitleFilter: (val) => {
      if (val.length > 32) {
      return val.slice(0, 32) + '...'
      } else {
      return val
      }
    }
  },
  methods: {
    drawer(flg) {
      this.sopen = flg
    },
    searche() {
      this.$emit('search', this.searchInput)
    },
    detailsClick() {
      this.$emit('domore')
    },
    LandTrustData() {
      this.orgId = this.$route.query.orgId
      LandTrustWebPage({ orgId: this.orgId, tType: this.tType }).then(res => {
        this.listData = ''
        this.listData = res.data.rows.slice(0, 5)
      })
    },
    SupplyAndDemand() {
      this.orgId = this.$route.query.orgId
      SupplyAndDemandInfoWebPage({ orgId: this.OrgId, SdType: this.SdType, CType: this.cType }).then(res => {
        this.SupplyAndDemandData = ''
        this.SupplyAndDemandData = res.data.rows.slice(0, 5)
      })
    },
    InfoMain() {
      this.orgId = this.$route.query.orgId
      InfoMainWebPage({ orgId: this.orgId, infoType: this.infoType }).then(res => {
        this.InfoMainData = ''
        this.InfoMainData = res.data.rows.slice(0, 5)
      })
    },
    InfoMainClick(id) {
     const go = this.$router.resolve({ path: 'Textcontent', query: { id, sytype: 'InfoMain', orgId: this.orgId } })
     window.open(go.href, '_blank')
    },
    TextcontentClick(id) {
      const go = this.$router.resolve({ path: 'Textcontent', query: { id, sytype: 'LandTrust', orgId: this.orgId } })
      window.open(go.href, '_blank')
    },
    SupplyAndDemandClick(id) {
      const go = this.$router.resolve({ path: 'SupplyandDemandPage', query: { id, orgId: this.orgId } })
      window.open(go.href, '_blank')
    }
  },
  mounted() {
    this.LandTrustData()
    this.SupplyAndDemand()
    this.InfoMain()
  },
  watch: {
    tType: function(val, oldval) {
      this.LandTrustData()
    },
    SdType: function(val, oldval) {
      this.SupplyAndDemand()
    },
    cType: function(val, oldval) {
      this.SupplyAndDemand()
    },
    infoType: function(val, oldval) {
      this.InfoMain()
    }
  }
}
</script>

<style lang="less" scoped>
.t-bar {
  height: 40px;
  line-height: 40px;
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  letter-spacing: 5px;
  margin-top: -60px;
  float: right;
  .b-left {
    flex: 1;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    .b-icon {
      width: 25px;
      height: 25px;
      margin-left: 15px;
      margin-right: 10px;
    }
  }
  .b-right {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;

    .b-search {
      flex: 1;
      margin-right: 10px;
      cursor: pointer;
      border: 1px solid #333;
      height: 34px;
      // width: 32px;
      overflow: hidden;
      border-radius: 5px;
      // display: flex;
      flex-flow: row column;
      .s-input {
        line-height: 20px;
        margin-right: 5px;
        width: 140px;
        float: left;
      }
      .s-btn {
        margin-top: 7px;
        margin-right: 10px;
        margin-left: 10px;
        height: 20px;
        width: 20px;
        float: right;
        background-image: url('~@/assets/icon/sousuo_2.png');
      }
    }
    .b-more {
      cursor: pointer;
    }
  }
}
</style>
